import { render, staticRenderFns } from "./ParticipantSignature.vue?vue&type=template&id=23488494&scoped=true"
import script from "./ParticipantSignature.vue?vue&type=script&lang=js"
export * from "./ParticipantSignature.vue?vue&type=script&lang=js"
import style0 from "./ParticipantSignature.vue?vue&type=style&index=0&id=23488494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23488494",
  null
  
)

export default component.exports